import React from 'react';
import UbiAgreeBottomSheet, {UbiAgreeBottomSheetProps} from '@di-shared/features/ubi/UbiAgreeBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import Environment from '@di-shared/features/environment/Environment';
import UbiAgreeBottomSheetEu from '@di-shared/features/home/eu/benefit/UbiAgreeBottomSheet.eu';
import UbiAgreeBottomSheetNa from '@di-shared/features/home/na/benefit/UbiAgreeBottomSheet.na';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function UbiAgreeBottomSheetPage() {
  const {vin, serviceId, termsData, agreeInfo, companyName} = (window as any).data as UbiAgreeBottomSheetProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <>
        <Environment.Kr>
          <UbiAgreeBottomSheet
            vin={vin}
            serviceId={serviceId}
            termsData={termsData}
            agreeInfo={agreeInfo}
            companyName={companyName}
          />
        </Environment.Kr>
        <Environment.Eu>
          <UbiAgreeBottomSheetEu />
        </Environment.Eu>
        <Environment.Na>
          <UbiAgreeBottomSheetNa />
        </Environment.Na>
      </>
    </BottomSheetWebViewWrapper>
  );
}

export default UbiAgreeBottomSheetPage;
